import { render, staticRenderFns } from "./SettingDashboard.vue?vue&type=template&id=5ecb20b7&scoped=true&"
import script from "./SettingDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SettingDashboard.vue?vue&type=style&index=0&id=5ecb20b7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb20b7",
  null
  
)

export default component.exports